export default "__VITE_ASSET__plf1cvxa__"